import { IHeaderMenu } from '../interfaces/portfolio-header-menu.interface';

export const portfolioHeaderMenuData: IHeaderMenu[] = [
  {
    id: 0,
    title: 'portfolio.header.products',
    icon: 'box',
    route: 'top-products',
  },
  {
    id: 1,
    title: 'portfolio.header.aboutUs',
    icon: 'info-circle',
    route: 'about-us',
  },
  {
    id: 2,
    title: 'portfolio.header.teamMember',
    icon: 'users',
    route: 'team-members',
  },
  {
    id: 3,
    title: 'portfolio.header.contactUs',
    icon: 'phone-ringing',
    route: 'contactUs',
  },
  // {
  //   id: 4,
  //   title: 'portfolio.header.explore',
  //   icon: 'gps',
  //   route: 'explore',
  // },
];
